'use client';

import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

type Props = {
  className?: string;
  title: ReactNode;
  children: ReactNode;
  isOpenDefault?: boolean;
};

const Accordion = ({ className = '', title, children, isOpenDefault = false }: Props) => {
  const [isOpen, setIsOpen] = useState(isOpenDefault);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div className={cn('rounded border border-amber-200 bg-white/30', className)}>
      <button
        onClick={toggleOpen}
        className="flex w-full items-center justify-between p-2 pr-4 pl-4 text-left text-amber-950"
      >
        {title}
        {isOpen ? (
          <ChevronUpIcon className="h-5 w-5 text-amber-950" />
        ) : (
          <ChevronDownIcon className="h-5 w-5 text-amber-950" />
        )}
      </button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            style={{ overflow: 'hidden' }}
          >
            <div className="p-4">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Accordion;
